// Contract/InspectionManager.tsx
import React from 'react';
import { Milestone, ProposedDates } from './Contract.interface';
import InspectionMilestones from './InspectionMilestones';

interface InspectionManagerProps {
  milestones: Milestone[];
  maxInspectionDays: number;
  isModalOpen: boolean;
  toggleModal: () => void;
  onDatesSet: (dates: ProposedDates) => Promise<void>;
  onDateSelected: (selectedDate: string) => Promise<void>;
  proposedDates: ProposedDates | null;
  selectedDate: string | null;
  isContractor: boolean;
}

const InspectionManager: React.FC<InspectionManagerProps> = ({
  milestones,
  maxInspectionDays,
  isModalOpen,
  toggleModal,
  onDatesSet,
  onDateSelected,
  proposedDates,
  selectedDate,
  isContractor
}) => {
  const hasInspectionMilestones = milestones.some(milestone => milestone.type === 'inspection');

  if (!hasInspectionMilestones) {
    return null;
  }

  return (
    <InspectionMilestones
      maxInspectionDays={maxInspectionDays}
      isModalOpen={isModalOpen}
      toggleModal={toggleModal}
      onDatesSet={onDatesSet}
      onDateSelected={onDateSelected}
      proposedDates={proposedDates}
      selectedDate={selectedDate}
      isContractor={isContractor}
      milestones={milestones}
    />
  );
};

export default InspectionManager;